import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { styled } from '../../../core/theme/styled';

type FlexBoxProps = {
  direction?: 'row' | 'column';
  alignItems?: 'center' | 'start';
  justifyContent?:
    | 'center'
    | 'normal'
    | 'space-between'
    | 'space-around'
    | 'flex-end'
    | 'flex-start';
  grow?: number;
};

export const FlexBox = styled(Box)<FlexBoxProps>`
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  ${({ alignItems }) =>
    alignItems &&
    `
    align-items: ${alignItems};
  `}
  ${({ justifyContent }) =>
    justifyContent &&
    `
    justify-content: ${justifyContent};
  `}
  flex-grow: ${(props) => props.grow || 0};
`;
